// AppContext.js
import { createContext, useState, useEffect } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [webStories, setWebStories] = useState([]);
  const [suvichar, setSuvichar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [podcasts, setSodcasts] = useState(true);
  const [notification, setNotification] = useState(true);


    const sendClickStatus = async (post_id, status) => {
    try {
      const response = await fetch("https://hondaapi.clientcoding.com/api/click", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ post_id, status }),
      });

      const data = await response.json();
      console.log("Click/Share status sent:", data);
    } catch (error) {
      console.error("Error sending click/share status:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch posts
        const postsRes = await fetch("https://hondaapi.clientcoding.com/api/posts");
        const postsData = await postsRes.json();
        setUsers(postsData.data);

        // Fetch web stories
        const storiesRes = await fetch("https://hondaapi.clientcoding.com/api/webstory");
        const storiesData = await storiesRes.json();
        setWebStories(storiesData.data);

        // Fetch web stories
        const suvicharRes = await fetch("https://hondaapi.clientcoding.com/api/suvichar");
        const suvicharData = await suvicharRes.json();
        setSuvichar(suvicharData.data);

         const podcast = await fetch("https://hondaapi.clientcoding.com/api/podcast");
        const podcastData = await podcast.json();
        setSodcasts(podcastData.data);


              const notification = await fetch("https://hondaapi.clientcoding.com/api/notification");
        const notificationData = await notification.json();
        setNotification(notificationData.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <AppContext.Provider value={{ users, webStories, loading,suvichar,podcasts,notification,sendClickStatus}}>
      {children}
    </AppContext.Provider>
  );
};
